import baseAttribute from "../../../../form/src/common/component-base-attribute";
import { ControlAttributeType } from "../../../../form/typings";
import i18n from "../../../i18n";
export default {
    groups: {
        base: {
            label: "基础信息",
            keys: ["name", "labelVisible", "visible", "style", "tips", "widgetType"],
        },
        controller: {
            label: "控制属性",
            keys: [],
        },
    },
    properties: {
        name: Object.assign({}, baseAttribute.name),
        dataItemName: Object.assign({}, baseAttribute.dataItemName),
        style: Object.assign({}, baseAttribute.style),
        widgetType: Object.assign({}, baseAttribute.widgetType, { value: i18n.t('dataitem.SequenceNo').toString() }),
        dataItemType: Object.assign({}, baseAttribute.dataItemType, { value: i18n.t('dataitem.ShortText2').toString() }),
        // 流水号编码
        prefix: {
            options: {
                regexps: {
                    maxLength: {
                        len: 200,
                        message: i18n.t('dataitem.ValidityErrTips', { num: 200 }).toString(),
                    },
                },
            },
        },
        // 最大长度
        maxLength: {
            inputMethod: ControlAttributeType.Dropdown,
            options: {
                list: [
                    {
                        value: "4",
                        label: "4",
                    },
                    {
                        value: "5",
                        label: "5",
                    },
                    {
                        value: "6",
                        label: "6",
                    },
                    {
                        value: "7",
                        label: "7",
                    },
                    {
                        value: "8",
                        label: "8",
                    },
                    {
                        value: "9",
                        label: "9",
                    },
                    {
                        value: "10",
                        label: "10",
                    },
                ],
            },
        },
        // 重置策略时间
        resetDate: {
            inputMethod: ControlAttributeType.Dropdown,
            options: {
                list: [
                    {
                        value: "none",
                        label: i18n.t('dataitem.NotReset').toString(),
                    },
                    {
                        value: "DAY",
                        label: i18n.t('dataitem.Daily').toString(),
                    },
                    {
                        value: "MONTH",
                        label: i18n.t('dataitem.Monthly').toString(),
                    },
                    {
                        value: "YEAR",
                        label: i18n.t('dataitem.Yearly').toString(),
                    },
                ],
            },
        },
        // 连接符
        delimiter: {
            inputMethod: ControlAttributeType.Dropdown,
            options: {
                allowClear: true,
                list: [
                    {
                        value: "mark1",
                        label: "-",
                    },
                    {
                        value: "mark2",
                        label: "#",
                    },
                    {
                        value: "mark3",
                        label: "_",
                    },
                ],
                callback: (key, attr, attrs, vm) => {
                    let val = attr.value || "";
                    vm.updateAttribute(key, "delimiter", val);
                },
            },
        },
    },
};
